import type { DatasetsMutatorUpdateDatasetProps } from "./datasets-mutator-update-dataset.type";

import { useDatasetsMutatorUpdateDataset } from "./datasets-mutator-update-dataset.hook";

const DatasetsMutatorUpdateDataset = (
  props: DatasetsMutatorUpdateDatasetProps
) => {
  useDatasetsMutatorUpdateDataset(props);

  return null;
};

export default DatasetsMutatorUpdateDataset;
